import React from 'react';
import PropTypes from 'prop-types';

import CroppedImage from 'rebook/apps/utils/components/CroppedImage';

import styles from './style.scss';


const BooksetAuthor = ({ avatar, is_fake_email: isFakeEmail, display_name: displayName }) => (
  <div className={styles.author}>
    <CroppedImage
      className={styles.authorImage}
      src={avatar}
      width="40"
      height="40"
      alt={displayName} />
    <div className={styles.authorInfo}>
      {isFakeEmail ? (
        <div className={styles.authorName}>Анонимный пользователь</div>
      ) : (
        <React.Fragment>
          <div className={styles.authorName}>{displayName}</div>
          <div className={styles.note}>Полку собрал</div>
        </React.Fragment>
      )}
    </div>
  </div>
);

BooksetAuthor.propTypes = {
  avatar: PropTypes.string.isRequired,
  is_fake_email: PropTypes.bool,
  display_name: PropTypes.string,
};

export default BooksetAuthor;
